module.exports = __webpack_public_path__ + "media/images/countryrect/bf-0f92a915e8f920aa84f703f94452ad02.svg";